import React, { useState } from 'react';
import { Accordion, AccordionItem, AccordionItemHeading, AccordionItemButton, AccordionItemPanel } from 'react-accessible-accordion';
import keys from 'ramda/src/keys';
import path from 'ramda/src/path';
import Avatar from '@components/@core/Avatar';
import Pagination from '@components/@core/Pagination';
import { inPage } from '~/services/util';

const ListHeader = () => (
    <div className="desktop-flex py-2 border-bottom">
        <div className="d-flex-4 minw-240 ssm-mw-unset dsl-m12 d-v-end">Departments</div>
        <div className="d-flex-2 minw-140 ssm-mw-unset text-end">
            <p className="dsl-m12 my-0 mx-2 mx-sm-0">Scorecard</p>
            <p className="dsl-m12 my-0 mx-2 mx-sm-0">Goals Actuals</p>
            <p className="dsl-m12 my-0 mx-2 mx-sm-0">Saved</p>
        </div>
        <div className="d-flex-2 minw-140 ssm-mw-unset text-end">
            <p className="dsl-m12 my-0 mx-2 mx-sm-0">Health Plan</p>
            <p className="dsl-m12 my-0 mx-2 mx-sm-0">Goals Actuals</p>
            <p className="dsl-m12 my-0 mx-2 mx-sm-0">Saved</p>
        </div>
        <div className="d-flex-2 minw-140 ssm-mw-unset text-end">
            <p className="dsl-m12 my-0 mx-2 mx-sm-0">Certifications</p>
            <p className="dsl-m12 my-0 mx-2 mx-sm-0">Goals Actuals</p>
            <p className="dsl-m12 my-0 mx-2 mx-sm-0">Saved</p>
        </div>
        <div className="d-flex-2 minw-140 ssm-mw-unset text-end">
            <p className="dsl-m12 my-0 mx-2 mx-sm-0">Total</p>
            <p className="dsl-m12 my-0 mx-2 mx-sm-0">Goals Actuals</p>
            <p className="dsl-m12 my-0 mx-2 mx-sm-0">Saved</p>
        </div>
        <div className="d-flex-1" />
    </div>
);

const SaveActualEmployeeReport = ({ data, companyId, onKeyChange }) => {
    const departmentsGroup = companyId.map((id) => path(['companies', id], data));
    return departmentsGroup.map((group) => {
        if (!group?.departments) return null;
        const { departments } = group;
        return (
            <div key={group.id}>
                <p className="dsl-b14 text-500 mb-2">{group.name}</p>
                <ListHeader />
                <Accordion className="saveactuals-accordion" allowMultipleExpanded allowZeroExpanded>
                    {keys(departments).map((key, index) => {
                        const users = departments[key].users || [];
                        const totals = departments[key]?.totals || {};
                        const [page, setPage] = useState(1);
                        const [per, setPer] = useState(25);
                        return (
                            <AccordionItem key={`saveactuals-${index}`} onClick={() => onKeyChange(key)}>
                                <AccordionItemHeading>
                                    <AccordionItemButton>
                                        <div className="dsl-b14 ms-4 ssm-l-0 d-flex-3">{key}</div>
                                        <div className="d-flex d-flex-8">
                                            <div className="d-flex-2 minw-140 ssm-mw-unset text-end">
                                                <p className="dsl-b14 my-0">
                                                    {totals.scorecard_quotas.saved}/{totals.scorecard_quotas.assigned}
                                                </p>
                                                <p className="dsl-m12 my-0 mx-2 mx-sm-0">{totals.scorecard_quotas.percent}%</p>
                                            </div>
                                            <div className="d-flex-2 minw-140 ssm-mw-unset text-end">
                                                <p className="dsl-b14 my-0 mx-0">
                                                    {totals.career_quotas.saved}/{totals.career_quotas.assigned}
                                                </p>
                                                <p className="dsl-m12 my-0 mx-2 mx-sm-0">{totals.career_quotas.percent}%</p>
                                            </div>
                                            <div className="d-flex-2 minw-140 ssm-mw-unset text-end">
                                                <p className="dsl-b14 my-0 mx-0">
                                                    {totals.certification_quotas.saved}/{totals.career_quotas.assigned}
                                                </p>
                                                <p className="dsl-m12 my-0 mx-2 mx-sm-0">{totals.career_quotas.percent}%</p>
                                            </div>
                                            <div className="d-flex-2 minw-140 ssm-mw-unset text-end">
                                                <p className="dsl-b14 my-0 mx-0 pe-3">{totals.all_quotas.percent}%</p>
                                            </div>
                                        </div>
                                        <div className="d-flex-1" />
                                    </AccordionItemButton>
                                </AccordionItemHeading>
                                <AccordionItemPanel>
                                    {users?.length > 0 && (
                                        <>
                                            {users.map(
                                                (item, index) =>
                                                    inPage(index, page, per) && (
                                                        <div key={item?.id} className="emp-list d-flex ssm-column py-3 border-bottom ps-sm-0">
                                                            <div className="d-h-start d-flex-4 dsl-m12 mb-ssm-2">
                                                                <Avatar name={item?.name} url={item?.avatar} />
                                                                <span className="dsl-b14 ms-3 text-break">{item?.name}</span>
                                                            </div>
                                                            <div className="d-flex-2 minw-140 ssm-mw-unset text-end text-sm-left d-flex flex-row flex-sm-column">
                                                                <label className="dsl-b14 w-50 mobile-screen me-2">Scorecard Quotas</label>
                                                                <p className="dsl-b14 my-0">
                                                                    {item?.report?.scorecard_quotas?.saved || 0}/{item?.report?.scorecard_quotas?.assigned || 0}
                                                                </p>
                                                                <p className="dsl-m12 my-0 mx-2 mx-sm-0">{item?.report?.scorecard_quotas?.percent || 0}%</p>
                                                            </div>
                                                            <div className="d-flex-2 minw-140 ssm-mw-unset text-end text-sm-left d-flex flex-row flex-sm-column">
                                                                <label className="dsl-b14 w-50 mobile-screen me-2">Scorecard Quotas</label>
                                                                <p className="dsl-b14 my-0">
                                                                    {item?.report?.career_quotas?.saved || 0}/{item?.report?.career_quotas?.assigned || 0}
                                                                </p>
                                                                <p className="dsl-m12 my-0 mx-2 mx-sm-0">{item?.report?.career_quotas?.percent || 0}%</p>
                                                            </div>
                                                            <div className="d-flex-2 minw-140 ssm-mw-unset text-end text-sm-left d-flex flex-row flex-sm-column">
                                                                <label className="dsl-b14 w-50 mobile-screen me-2">Scorecard Quotas</label>
                                                                <p className="dsl-b14 my-0">
                                                                    {item?.report?.certification_quotas?.saved || 0}/{item?.report?.certification_quotas?.assigned || 0}
                                                                </p>
                                                                <p className="dsl-m12 my-0 mx-2 mx-sm-0">{item?.report?.certification_quotas?.percent || 0}%</p>
                                                            </div>
                                                            <div className="d-flex-2 minw-140 ssm-mw-unset text-end text-sm-left d-flex flex-row flex-sm-column">
                                                                <label className="dsl-b14 w-50 mobile-screen me-2">Scorecard Quotas</label>
                                                                <p className="dsl-b14 my-0">{item?.report?.all_quotas?.percent || 0}%</p>
                                                            </div>
                                                            <div className="d-flex-1 a-h-end" />
                                                        </div>
                                                    )
                                            )}
                                            <Pagination current={page} total={Math.ceil(users?.length / per)} per={per} onChange={(e) => setPage(e)} onPer={(e) => setPer(e)} />
                                        </>
                                    )}
                                </AccordionItemPanel>
                            </AccordionItem>
                        );
                    })}
                </Accordion>
            </div>
        );
    });
};

export default SaveActualEmployeeReport;
